export const ORGANIZATION_TYPE = {
  GROUP: 'GROUP',
  SUBSIDIARY: 'SUBSIDIARY',
  BRANCH: 'BRANCH',
  ACQUISITION_SITE: 'ACQUISITION_SITE',
  DEPARTMENT: 'DEPARTMENT',
} as const;
export type OrganizationType = (typeof ORGANIZATION_TYPE)[keyof typeof ORGANIZATION_TYPE];

export const RECORD_STATUS = { ACTIVE: 'ACTIVE', DISABLED: 'DISABLED' } as const;
export type RecordStatus = (typeof RECORD_STATUS)[keyof typeof RECORD_STATUS];

export const ROLE_CODE = {
  PLATFORM_ADMIN: 'PLATFORM_ADMIN',
  GROUP_ADMIN: 'GROUP_ADMIN',
  ORG_ADMIN: 'ORG_ADMIN',
  APPLICANT: 'APPLICANT',
  LOCAL_MANAGER: 'LOCAL_MANAGER',
  HQ_FINANCE: 'HQ_FINANCE',
  HQ_LEADER: 'HQ_LEADER',
  HQ_CASHIER: 'HQ_CASHIER',
  AUDITOR: 'AUDITOR',
} as const;
export type RoleCode = (typeof ROLE_CODE)[keyof typeof ROLE_CODE];

export const DATA_SCOPE_TYPE = {
  SELF: 'SELF',
  ORG: 'ORG',
  ORG_AND_DESCENDANTS: 'ORG_AND_DESCENDANTS',
  ASSIGNED_ORGS: 'ASSIGNED_ORGS',
  GROUP: 'GROUP',
  NONE: 'NONE',
} as const;
export type DataScopeType = (typeof DATA_SCOPE_TYPE)[keyof typeof DATA_SCOPE_TYPE];

export const PERMISSION_CODE = {
  SYSTEM_OPERATE: 'system:operate',
  ORGANIZATION_READ: 'organization:read',
  ORGANIZATION_MANAGE: 'organization:manage',
  USER_READ: 'user:read',
  USER_MANAGE: 'user:manage',
  ROLE_READ: 'role:read',
  ROLE_BIND: 'role:bind',
  WECOM_SYNC: 'wecom:sync',
  AUDIT_READ: 'audit:read',
  MASTER_DATA_READ: 'master-data:read',
  MASTER_DATA_MANAGE: 'master-data:manage',
  DOCUMENT_CREATE_SELF: 'document:create:self',
  DOCUMENT_READ_SELF: 'document:read:self',
  DOCUMENT_READ_SCOPE: 'document:read:scope',
  APPROVAL_DECIDE: 'approval:decide',
  APPROVAL_TRANSFER: 'approval:transfer',
  PAYMENT_READ: 'payment:read',
  PAYMENT_PROCESS: 'payment:process',
  PAYMENT_CORRECTION_INITIATE: 'payment:correction:initiate',
  PAYMENT_CORRECTION_REVIEW: 'payment:correction:review',
  LOAN_OFFSET_RESOLVE: 'loan-offset:resolve',
  COLLECTION_CONFIRM: 'collection:confirm',
  LEDGER_READ: 'ledger:read',
  LEDGER_EXPORT: 'ledger:export',
} as const;
export type PermissionCode = (typeof PERMISSION_CODE)[keyof typeof PERMISSION_CODE];

export interface AccessContextSummary {
  userId: string;
  roleCodes: RoleCode[];
  permissions: PermissionCode[];
  scopeTypes: DataScopeType[];
  allowedOrganizationIds: string[];
}
